export default function CampaignCard({ campaign, onDonate }) {
  const percentage = Math.min(
    Math.round((campaign.raised_amount / campaign.target_amount) * 100),
    100
  )

  return (
    <div className={`border p-5 sm:p-7 ${
      campaign.status === 'active'
        ? 'bg-green-50 dark:bg-green-950/20 border-green-200 dark:border-green-900/40'
        : 'bg-gray-50 dark:bg-white/5 border-gray-200 dark:border-white/10'
    }`}>
      {campaign.status !== 'active' && (
        <div className="inline-block bg-green-100 dark:bg-green-900/30 border border-green-200 dark:border-green-800/50 text-green-600 dark:text-green-400 text-xs font-bold uppercase tracking-widest px-3 py-1 mb-4">
          Goal Reached
        </div>
      )}

      <h3 className="font-bold text-gray-900 dark:text-white text-base sm:text-lg leading-snug mb-4 sm:mb-5">
        {campaign.title}
      </h3>

      {campaign.description && (
        <p className="text-gray-500 text-sm leading-relaxed mb-4 sm:mb-5">
          {campaign.description}
        </p>
      )}

      <div className="bg-gray-200 dark:bg-white/10 h-2 mb-3">
        <div className="bg-green-500 h-2 transition-all" style={{ width: `${percentage}%` }} />
      </div>

      <div className="flex justify-between items-center mb-1 flex-wrap gap-2">
        <span className="text-green-600 dark:text-green-400 font-black text-lg sm:text-xl">
          ZMW {campaign.raised_amount.toLocaleString()}
        </span>
        <span className="text-gray-500 text-sm">
          of ZMW {campaign.target_amount.toLocaleString()}
        </span>
      </div>
      <div className="text-gray-400 text-xs mb-5 sm:mb-6">{percentage}% funded</div>

      {campaign.status === 'active' && (
        <button
          onClick={onDonate}
          className="w-full bg-green-600 hover:bg-green-700 text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors"
        >
          Donate Now
        </button>
      )}
    </div>
  )
}